import React, { useEffect } from 'react'
import { fetchLogSources } from '../../../../store/async-thunks/logs/fetchLogSources'
import { useAppDispatch } from '../../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../../hooks/useAppSelector'
import { selectOneSystemAction } from '../../../../store/selectors/systemActionsSelectors'
import { buildControlsExt } from '../../../inputs/controls'
import {
    formatLogSourceDetails,
    formLogSourceOptions,
    getLogSourcesControlDescriptors,
} from '../utils'
import {
    selectOneProductLogSources,
    selectServerLogSources,
} from '../../../../store/selectors/logsSelectors'
import { LOG_SOURCE_DEFAULT } from '../types'
import { fetchServerLogSources } from '../../../../store/async-thunks/logs/fetchServerLogSources'

interface LogSourceProps {
    guid: string
    logsState: any
    setLogsState: any
    isServerLogs: boolean
}

export const LogSource = (props: LogSourceProps) => {
    const { guid = 'undefined', logsState, setLogsState, isServerLogs } = props

    const dispatch = useAppDispatch()
    const hasGetLogSources = useAppSelector(
        selectOneSystemAction(guid, 'get_log_sources')
    )
    const serverLogSources = useAppSelector(selectServerLogSources) ?? []
    const productLogSources = useAppSelector(selectOneProductLogSources(guid)) ?? []
    const targetLogSources = isServerLogs ? serverLogSources : productLogSources

    const logSourceOptions = formLogSourceOptions(targetLogSources)
    const logSourcesDescriptors =
        getLogSourcesControlDescriptors(logSourceOptions)
    const logSourceExtension = buildControlsExt(
        logSourcesDescriptors,
        logsState,
        setLogsState
    )
    const isLogSourceSelected = logsState.logSource.label !== LOG_SOURCE_DEFAULT
    const logSourceSelected = isLogSourceSelected
        ? targetLogSources.find((source) => source.path === logsState.logSource.value)
        : null
    const logSourceDetails = formatLogSourceDetails(logSourceSelected)

    useEffect(() => {
        if (isServerLogs) {
            dispatch(fetchServerLogSources())
        } else {
            dispatch(fetchLogSources({ productGuid: guid }))
        }
    }, [guid, fetchLogSources, fetchServerLogSources, dispatch])

    return (
        <>
            {(isServerLogs || hasGetLogSources) && (
                <div className="mt-3">{logSourceExtension}</div>
            )}
            {isLogSourceSelected && logSourceDetails && (
                <div className="d-flex align-items-center mt-3">
                    <div style={{ width: '30%' }} />
                    <div
                        style={{ width: '70%', fontSize: '1rem' }}
                        className="mt-3 d-flex flex-column gap-1"
                    >
                        {Object.entries(logSourceDetails).map(
                            ([key, value]) => (
                                <div className="d-flex">
                                    <div style={{ width: '52%' }}>{key}:</div>
                                    <div
                                        style={{
                                            width: '43%',
                                            fontWeight: 600,
                                        }}
                                    >
                                        {value}
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            )}
        </>
    )
}
